import { map, type Observable } from 'rxjs';
import { first } from 'lodash-es';
import type {
    FeatureCheckProjectQuery,
    FeatureCheckSwarmQuery,
    SwarmFeaturesFieldsFragment,
} from '@/graphql/types';
import { getClient } from '../../../utils/apollo-client';
import { fromObservableQuery } from '../../../utils/rxjs';
import { DEVICE_FEATURES_QUERY, PROJECT_FEATURES_QUERY } from './queries';

export function featureCheckSwarm$(deviceName: string): Observable<SwarmFeaturesFieldsFragment[]> {
    const queryParameters = {
        variables: { deviceName },
        query: DEVICE_FEATURES_QUERY,
    };

    return fromObservableQuery(
        getClient().watchQuery<FeatureCheckSwarmQuery>(queryParameters)
    ).pipe(
        map((result) => {
            const deviceResult = first(result.data!.featureCheckSwarm);

            if (!deviceResult) {
                throw new Error(
                    `The 'featureCheckSwarm' query did not return anything for the sensor named '${deviceName}'.`
                );
            }

            return result.data!.featureCheckSwarm as SwarmFeaturesFieldsFragment[];
        })
    );
}

export function featureCheckProject$(projectId: string) {
    const queryParameters = {
        variables: { projectId },
        query: PROJECT_FEATURES_QUERY,
    };

    return fromObservableQuery(
        getClient().watchQuery<FeatureCheckProjectQuery>(queryParameters)
    ).pipe(map((result) => result.data!.featureCheckProject as SwarmFeaturesFieldsFragment[]));
}
